export default __webpack_public_path__ + "static/twilio-hero-img-bd32b11af3d4097be71dd6c92f00e149.png";